import React from "react";
import { useNavigate } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: "Create Contest",
      description: "Set up a new contest with date and reward",
      route: "/admin/create-contest",
      emoji: "🗓️",
    },
    {
      title: "Manage Contest",
      description: "Edit or delete existing contests",
      route: "/admin/manage-contests",
      emoji: "🛠️",
    },
    {
      title: "Manage Questions",
      description: "Add/edit/delete contest questions",
      route: "/admin/questions",
      emoji: "📝",
    },
    {
      title: "View Registrations",
      description: "See who registered for each contest",
      route: "/admin/registrations",
      emoji: "📋",
    },
    {
      title: "Leaderboard",
      description: "View results and top scorers",
      route: "/admin/leaderboard",
      emoji: "🏆",
    },
    {
      title: "Declare Winners",
      description: "Announce and manage winners",
      route: "/admin/winners",
      emoji: "🎖️",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-24 px-4 pb-10">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Admin Dashboard
        </h1>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {actions.map((action, index) => (
            <div
              key={index}
              onClick={() => navigate(action.route)}
              className="cursor-pointer bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition"
            >
              <div className="text-4xl mb-3">{action.emoji}</div>
              <h2 className="text-xl font-semibold text-gray-800">
                {action.title}
              </h2>
              <p className="text-gray-600 text-sm mt-1">{action.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
